export const bgHeight = "65%";
